const deleteChecklistButton = {
  text: 'Delete Checklist'
};

export default deleteChecklistButton;
